import React, { useState, useEffect, Fragment } from 'react';
import { Breadcrumbs, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row, Input, Media } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { User, Edit } from 'react-feather';
import { fetchTableData } from '../../../Api/ApiMethods';
import { useNavigate } from 'react-router-dom';

const Accidents = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);

    const accidentApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/accident';

    const handleSearch = (event) => {
        event.preventDefault();
        setSearch(event.target.value);
    };

    useEffect(() => {
        fetchTableData({
            apiEndpoint: accidentApiUrl,
            page,
            pageSize,
            search,
            setDataCallback: setData,
            setTotalRowsCallback: setTotalRows,
        });
    }, [page, pageSize, search]);

    const handleCustomerDetail = (customerId) => {
        navigate(`/customer/${customerId}`);
    };

    const columns = [
        {
            name: 'Müşteri',
            cell: row => {
                const customerId = row.licensePlate?.customer?.[0];
                return customerId ? (
                    <div className="btn btn-outline-primary d-flex align-items-center justify-content-center" onClick={() => handleCustomerDetail(customerId)}>
                        <User size={18}/>
                    </div>
                ) : '';
            },
            ignoreRowClick: true,
            allowOverflow: true,
            right: true,
            button: true,
        },
        { name: 'Kaza Numarası', selector: row => row.accidentNumber || '', sortable: true },
        { name: 'Kaza Tarihi', selector: row => row.accidentDate ? new Date(row.accidentDate).toLocaleDateString() : '', sortable: true },
        { 
            name: 'Atanan Uzmanlar', 
            selector: row => {
                if (!row.appointedExperts?.length) return '';
                return row.appointedExperts
                    .map(expertObj => expertObj.expert?.join(', '))
                    .filter(Boolean)
                    .join(', ') || '';
            },
            sortable: true 
        },
        { name: 'Karşı Taraf Plaka Numarası', selector: row => row.counterpartyLicensePlateNumber || '', sortable: true },
        { name: 'Plaka', selector: row => row.licensePlate?.licensePlateNumber || '', sortable: true },
    ];

    return (
        <>
            <Breadcrumbs parent='Müşteri Alanları' title='Kazalar' />
            <Container fluid={true}>
                <Row>
                    <Col sm='12'>
                        <Card>
                            <CardHeader>
                                <H5>Kazalar</H5>
                                <span>Tanımlanmış olan kazalar aşağıda listelenmektedir.</span>
                            </CardHeader>
                            <CardBody>
                                <div className="d-flex justify-content-end align-items-center w-100 file-content flex-wrap">
                                    <div className='form-inline me-2 mt-3 p-0 custom-responsive-width'>
                                        <div className='mb-0 form-group d-flex align-items-center border rounded px-2' style={{ height: '35px' }}>
                                            <i className='fa fa-search text-muted'></i>
                                            <Input
                                                type="text"
                                                placeholder="Ara.."
                                                value={search}
                                                onChange={(e) => handleSearch(e)}
                                                className="border-0 ms-2 shadow-none"
                                                style={{ height: '33px', flexGrow: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div style={{ height: "40px" }}></div>

                                <Fragment>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        pagination
                                        paginationServer
                                        selectableRows={false}
                                        paginationTotalRows={totalRows}
                                        onChangePage={page => setPage(page)}
                                        onChangeRowsPerPage={pageSize => setPageSize(pageSize)}
                                    />
                                </Fragment>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Accidents;
